import React from 'react';

import { Box, H3, Link, Text } from '@betterment/samba-react';

const IntegrationsBanner: React.FC = () => {
  return (
    <Box
      css={{
        backgroundColor: 'background.surface',
        color: 'text',
        p: 'space.300',
        mt: 'space.400',
        mb: 'space.100',
        boxShadow: 'xs',
        borderRadius: 'medium',
      }}
    >
      <H3 color="text" variant="title200" css={{ pb: 'space.100' }}>
        Connect to your tech stack
      </H3>
      <Text color="text">
        Betterment Advisor Solutions’ integrations with other tools can help provide a better experience for you and
        your clients.{' '}
        <Link href="https://www.betterment.com/advisors/integrations" target="_blank" variant="textPrimary">
          Learn more
        </Link>
      </Text>
    </Box>
  );
};

export default IntegrationsBanner;
